module.exports = __webpack_public_path__ + "static/thri-kreen-ea0af8cd764e2c70fbf0b8907190fe14.jpeg";